
import { Component, Prop, Vue, Inject, Emit } from "vue-property-decorator";
import { FormErrors } from "../../../../common/src/form/types";
import { ConferenceBody } from "@gsx/common/src/types/http/dashboard/conference";
import FormInput from "../../../../landing/src/molecules/form/FormInput.vue";
import FormLabel from "../../../../landing/src/molecules/form/FormLabel.vue";
import FormMultiSelect from "../../../../landing/src/molecules/form/FormMultiSelect.vue";
import FormTextarea from "../../../../landing/src/molecules/form/FormTextarea.vue";
import FormSimpleMultiSelect from "../../../../landing/src/molecules/form/FormSimpleMultiSelect.vue";
import { EventTopic, EventType, Deadline } from "@gsx/common";
import FormDateTime from "../../../../landing/src/molecules/form/FormDateTime.vue";
import SimpleAddressFormGroup from "../../../../landing/src/molecules/form/SimpleAddressFormGroup.vue";
import { getEventTypes, getEventTopics } from "../../../../common/src/utility/entity/user";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { Container } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import { SelectOption } from "../../../../landing/src/molecules/form/types";

@Component({
    components: {
        SimpleAddressFormGroup,
        FormDateTime,
        FormSimpleMultiSelect,
        FormTextarea,
        FormMultiSelect,
        FormInput,
        FormLabel,
    },
})
export default class ConferenceForm extends Vue {
    @Prop() values!: ConferenceBody;
    @Prop() value?: File;
    @Prop() errors!: FormErrors<ConferenceBody>;
    @Inject("container") readonly container!: Container;
    readonly authStore: AuthStore = this.container.get(AuthStore);
    readonly organizationListStore: OrganizationListStore =
        this.container.get(OrganizationListStore);
    tempLogo: string | null = null;

    get topics(): EventTopic[] {
        return getEventTopics(this.authStore.user!);
    }

    get types(): EventType[] {
        return getEventTypes(this.authStore.user!);
    }

    get formattedDeadlines(): Deadline[] {
        return (
            this.values.deadlines?.sort((a, b) => (b.date.getTime() > a.date.getTime() ? -1 : 1)) ||
            []
        );
    }

    get organizations(): SelectOption[] {
        return this.organizationListStore.items
            ? this.organizationListStore.items.map((org) => ({
                  name: org.organizationName,
                  id: org.organizationid,
              }))
            : [];
    }

    get conferenceOrganizingOrganizations() {
        return this.values.organizingOrganizations;
    }

    @Emit()
    input(file: File | null) {
        return file;
    }

    addDeadlineRow() {
        const deadlineTemplate: Deadline = { date: this.values.startDate || new Date(), title: "" };
        this.values.deadlines
            ? this.values.deadlines.push(deadlineTemplate)
            : (this.values.deadlines = [deadlineTemplate]);
    }

    destroyDeadlineRow(index: number) {
        const newValue = [...this.formattedDeadlines];
        newValue.splice(index, 1);
        this.values.deadlines = newValue;
    }

    selectOrganizingOrganizations(option: SelectOption[]): void {
        this.values.organizingOrganizations = option.map((a) => a.name);
    }

    changeEventLogo(event: any) {
        const target: HTMLInputElement = event.target;
        const file = target.files && target.files[0];
        this.input(file);

        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.tempLogo = e.target.result;
            };
            reader.readAsDataURL(file);
        } else {
            this.tempLogo = null;
        }
    }
}
